import Lookup from 'src/componentes/select-async';
import PacoteEdit from 'src/paginas/matriz-orcamentaria/pacote/edit';
import PacoteList from 'src/paginas/matriz-orcamentaria/pacote/view';

const PacoteLookup = (props) => (
  <Lookup
    valueComponent={props.renderPacote}
    valueKey="id"
    labelKey="nome"
    showSearch
    clearable={true}
    url="/PacoteLookup"
    editComponent={PacoteEdit}
    searchComponent={PacoteList}
    {...props}
  />
);

export default PacoteLookup;
